module.exports = __webpack_public_path__ + "static/img/special-offers-img@w.57efe3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/special-offers-img@w.png
// module id = gXMn
// module chunks = 0